(function () {
  'use strict';

  // Custom engraving control: reveals a text input that writes
  // properties[Engraving] to the product form, with a live chars-left
  // counter. When the product exposes an "Engraving" Yes/No variant
  // option, the checkbox also drives that variant so the price applies.
  // Vanilla + defensive so it degrades gracefully in IG WebView.

  if (window.customElements && customElements.get('lm-engraving')) return;

  var PROP_NAME = 'properties[Engraving]';

  class LmEngraving extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('[data-lm-engraving-checkbox]');
      this.field = this.querySelector('[data-lm-engraving-field]');
      this.input = this.querySelector('[data-lm-engraving-input]');
      this.remaining = this.querySelector('[data-lm-engraving-remaining]');

      // Without the core controls there is nothing to enhance.
      if (!this.checkbox || !this.input) return;

      this.variantMode = this.dataset.variantMode === 'true';
      this.sectionId = this.dataset.sectionId || '';
      this.optionName = this.dataset.optionName || '';
      this.onValue = this.dataset.onValue || '';
      this.offValue = this.dataset.offValue || '';

      this._onToggle = this.onToggle.bind(this);
      this._onInput = this.onInput.bind(this);
      this.checkbox.addEventListener('change', this._onToggle);
      this.input.addEventListener('input', this._onInput);

      if (this.variantMode) {
        this.variantPicker = this.findVariantPicker();
        if (this.variantPicker) {
          this._onVariantChange = this.syncFromVariant.bind(this);
          // Variant changes bubble a `change` event to <variant-picker>.
          this.variantPicker.addEventListener('change', this._onVariantChange);
        }
      }

      this.updateCounter();
      this.updateSubmitName();
    }

    disconnectedCallback() {
      if (this.checkbox && this._onToggle) this.checkbox.removeEventListener('change', this._onToggle);
      if (this.input && this._onInput) this.input.removeEventListener('input', this._onInput);
      if (this.variantPicker && this._onVariantChange) {
        this.variantPicker.removeEventListener('change', this._onVariantChange);
      }
    }

    findVariantPicker() {
      var pickers = document.querySelectorAll('variant-picker');
      for (var i = 0; i < pickers.length; i++) {
        if (pickers[i].dataset.sectionId === this.sectionId) return pickers[i];
      }
      return null;
    }

    onToggle() {
      var on = this.checkbox.checked;
      this.reveal(on);
      if (this.variantMode) this.driveVariant(on);
      this.updateSubmitName();
      if (on) {
        try { this.input.focus(); } catch (e) {}
      }
    }

    onInput() {
      this.updateCounter();
      this.updateSubmitName();
    }

    reveal(show) {
      if (!this.field) return;
      if (show) this.field.removeAttribute('hidden');
      else this.field.setAttribute('hidden', '');
    }

    updateCounter() {
      if (!this.remaining) return;
      // The maxlength attribute is the single source of truth for the limit
      // (review P2-6) — no fallback number lives here.
      var max = parseInt(this.input.getAttribute('maxlength'), 10);
      if (!(max > 0)) return;
      var left = max - this.input.value.length;
      if (left < 0) left = 0;
      this.remaining.textContent = String(left);
    }

    // Only submit the property when engraving is on AND there's actual text,
    // so we never write an empty "Engraving:" line to the cart.
    updateSubmitName() {
      if (this.checkbox.checked && this.input.value.trim() !== '') {
        this.input.setAttribute('name', PROP_NAME);
      } else {
        this.input.removeAttribute('name');
      }
    }

    findRadio(value) {
      if (!this.variantPicker) return null;
      var radios = this.variantPicker.querySelectorAll('input[type="radio"]');
      var i;
      // Prefer the radio that belongs to the engraving option fieldset.
      for (i = 0; i < radios.length; i++) {
        if (radios[i].value === value && radios[i].name.indexOf(this.optionName + '-') === 0) {
          return radios[i];
        }
      }
      // Fallback: single-option products only have one fieldset.
      for (i = 0; i < radios.length; i++) {
        if (radios[i].value === value) return radios[i];
      }
      return null;
    }

    driveVariant(on) {
      var value = on ? this.onValue : this.offValue;
      if (!value) return;

      var radio = this.findRadio(value);
      if (radio) {
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      // Dropdown variant style.
      var select = this.variantPicker ? this.variantPicker.querySelector('select') : null;
      if (select) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === value) {
            if (select.selectedIndex !== i) {
              select.selectedIndex = i;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return;
          }
        }
      }
    }

    // Keep the checkbox in step when the variant is changed by other means
    // (direct click, or a server re-render that re-checks a radio).
    syncFromVariant() {
      var isOn = null;
      var onRadio = this.findRadio(this.onValue);
      if (onRadio) {
        isOn = onRadio.checked;
      } else {
        var select = this.variantPicker.querySelector('select');
        if (select) isOn = select.value === this.onValue;
      }
      if (isOn === null) return;
      if (this.checkbox.checked !== isOn) {
        this.checkbox.checked = isOn;
        this.reveal(isOn);
        this.updateSubmitName();
      }
    }
  }

  customElements.define('lm-engraving', LmEngraving);
})();
